import chessMoveSound from '../assets/sounds/chessmove.mp3'
import chessCaptureSound from '../assets/sounds/capturefinal.mp3'

class SoundManager {
  constructor() {
    this.sounds = {
      move: new Audio(chessMoveSound),
      capture: new Audio(chessCaptureSound)
    }
    this.timeouts = {
      move: null,
      capture: null
    }

    // Set volume to a reasonable level
    Object.values(this.sounds).forEach(sound => {
      sound.volume = 0.25
    })
  }

  playMoveSound() {
    try {
      // Clear any existing timeout
      if (this.timeouts.move) {
        clearTimeout(this.timeouts.move)
      }

      // Reset the audio to the beginning if it's already playing
      this.sounds.move.currentTime = 0
      this.sounds.move.play().catch(error => {
        // Handle cases where audio playback is blocked by browser
        console.log('Audio playback blocked by browser:', error)
      })

      // Stop audio after 0.5 seconds to eliminate white noise
      this.timeouts.move = setTimeout(() => {
        this.sounds.move.pause()
        this.sounds.move.currentTime = 0
      }, 500)
    } catch (error) {
      console.error('Error playing move sound:', error)
    }
  }

  playCaptureSound() {
    try {
      // Clear any existing timeout
      if (this.timeouts.capture) {
        clearTimeout(this.timeouts.capture)
      }

      // Reset the audio to the beginning if it's already playing
      this.sounds.capture.currentTime = 0
      this.sounds.capture.playbackRate = 1.0 // Reset to normal speed
      this.sounds.capture.play().catch(error => {
        // Handle cases where audio playback is blocked by browser
        console.log('Audio playback blocked by browser:', error)
      })

      // Stop audio after 0.5 seconds to eliminate white noise
      this.timeouts.capture = setTimeout(() => {
        this.sounds.capture.pause()
        this.sounds.capture.currentTime = 0
      }, 500)
    } catch (error) {
      console.error('Error playing capture sound:', error)
    }
  }

  // Helper method to play the appropriate sound based on move type
  playMoveOrCapture(isCapture) {
    if (isCapture) {
      this.playCaptureSound()
    } else {
      this.playMoveSound()
    }
  }

  setVolume(volume) {
    // Volume should be between 0 and 1
    const clampedVolume = Math.max(0, Math.min(1, volume))
    Object.values(this.sounds).forEach(sound => {
      sound.volume = clampedVolume
    })
  }
}

// Create a singleton instance
const soundManager = new SoundManager()

export default soundManager